import { tryAssetIdLikeToLegacyAssetId } from "@repo/caip";
import { getGliderTokenIcon } from "@repo/utils/token-icon-mappings";

const UNRELIABLE_TOKEN_IMAGE_HOSTS = new Set(["token-media.defined.fi"]);

function nonEmptyUrl(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

function isReliableTokenImageUrl(value: string): boolean {
  try {
    return !UNRELIABLE_TOKEN_IMAGE_HOSTS.has(new URL(value).hostname);
  } catch {
    return true;
  }
}

/**
 * Resolves an execution token image from collection-backed metadata first.
 * Glider's CDN replaces provider-hosted URLs known to be blocked by common
 * browser privacy filters, while API/portfolio metadata remains available for
 * assets without a Glider-hosted icon (for example tokenized equities).
 */
export function resolveExecutionAssetImageUrl(input: {
  readonly assetId: string;
  readonly collectionImageUrl?: string | null;
  readonly fallbackImageUrl?: string | null;
}): string | null {
  const metadataUrls = [
    nonEmptyUrl(input.collectionImageUrl),
    nonEmptyUrl(input.fallbackImageUrl),
  ].filter((value): value is string => value !== null);
  const reliableMetadataUrl = metadataUrls.find(isReliableTokenImageUrl);
  if (reliableMetadataUrl) {
    return reliableMetadataUrl;
  }

  const legacyAssetId = tryAssetIdLikeToLegacyAssetId(input.assetId);
  const gliderIcon = getGliderTokenIcon(legacyAssetId ?? input.assetId);
  return gliderIcon?.cdnUrl ?? metadataUrls[0] ?? null;
}
